import { Outlet, useLocation, useNavigate } from "react-router-dom";
// material
import { Stack, Tab, Tabs, Typography } from "@mui/material";

import Page from "@components/Page";
import { PATH_ADMIN } from "@routes/paths";

const TABS = [
  { label: "유저 관리", path: PATH_ADMIN.users },
  { label: "멤버십 관리", path: PATH_ADMIN.memberships },
  { label: "본인인증 수준", path: PATH_ADMIN.identity },
];

/**
 * 관리자 화면의 껍데기. 탭은 URL 이 정한다.
 *
 * 공용 `TabContents` 를 쓰지 않았다. 그쪽은 선택된 탭을 컴포넌트 안의 `useState` 로
 * 들고 있어서 **주소로 특정 탭을 열 수 없다.** 가입 신청 알림 메일이 보내는 링크가
 * `/admin/users?request=<신청ID>` 라서, 주소가 탭을 정할 수 있어야 한다.
 * (그 링크를 실제로 소비하는 것은 스프린트 4다.)
 */
export default function Admin() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const matched = TABS.findIndex((tab) => pathname.startsWith(tab.path));
  const value = matched === -1 ? 0 : matched;

  return (
    <Page title="관리자">
      <Stack spacing={3}>
        <Typography variant="h5" component="h1">
          관리자
        </Typography>
        <Tabs value={value} onChange={(_, next) => navigate(TABS[next].path)}>
          {TABS.map((tab) => (
            <Tab key={tab.path} label={tab.label} />
          ))}
        </Tabs>
        <Outlet />
      </Stack>
    </Page>
  );
}
